import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import './index.css';
import { signOut, getMe } from "../../store/actions/Auth";

const NavbarInner = ({ breadcrumbs = null }) => {
    const dispatch = useDispatch();
    const logout = () => dispatch(signOut());
    const { auth, email, role } = useSelector(st => st['Auth']);

    // Fetch role once per page load so the manager badge reflects the current DB value
    useEffect(() => { if (auth && role === null) dispatch(getMe()) }, [auth]);

    return (
        <div
            className={`navbar-main ${Array.isArray(breadcrumbs) && breadcrumbs.length > 0
                ? 'with-breadcrumb'
                : ''
                }`}
        >
            {Array.isArray(breadcrumbs) && breadcrumbs.length > 0 && (
                <div className="breadcrumb">
                    {breadcrumbs.map((item, idx) => {
                        const isLast = idx === breadcrumbs.length - 1;

                        return (
                            <span key={`${item.label}-${idx}`} className="breadcrumb-item">
                                {item.to && !isLast ? (
                                    <Link to={item.to}>
                                        <i className="icon mr-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14">
                                                <path fill="#01194D" transform="matrix(-4.37114e-08 1 -1 -4.37114e-08 16 4.76837e-07)" d="M6.2937498 10.70625C6.6843748 11.096875 7.3187499 11.096875 7.7093749 10.70625L12.709375 5.7062502C13.1 5.3156252 13.1 4.6812496 12.709375 4.2906246C12.31875 3.8999996 11.684376 3.8999996 11.293751 4.2906246L7 8.5843754L2.7062502 4.2937498C2.3156252 3.9031248 1.6812501 3.9031248 1.2906251 4.2937498C0.9000001 4.6843748 0.9000001 5.3187504 1.2906251 5.7093754L6.2906251 10.709375L6.2937498 10.70625Z" />
                                            </svg>
                                        </i>
                                        {item.label}
                                    </Link>
                                ) : item.onClick && !isLast ? (
                                    <a onClick={item.onClick} style={{ cursor: 'pointer' }}>
                                        <i className="icon mr-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14">
                                                <path fill="#01194D" transform="matrix(-4.37114e-08 1 -1 -4.37114e-08 16 4.76837e-07)" d="M6.2937498 10.70625C6.6843748 11.096875 7.3187499 11.096875 7.7093749 10.70625L12.709375 5.7062502C13.1 5.3156252 13.1 4.6812496 12.709375 4.2906246C12.31875 3.8999996 11.684376 3.8999996 11.293751 4.2906246L7 8.5843754L2.7062502 4.2937498C2.3156252 3.9031248 1.6812501 3.9031248 1.2906251 4.2937498C0.9000001 4.6843748 0.9000001 5.3187504 1.2906251 5.7093754L6.2906251 10.709375L6.2937498 10.70625Z" />
                                            </svg>
                                        </i>
                                        {item.label}
                                    </a>
                                ) : (
                                    <span className="current">
                                        <i className="icon mr-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14">
                                                <path fill="#01194D" transform="matrix(-4.37114e-08 1 -1 -4.37114e-08 16 4.76837e-07)" d="M6.2937498 10.70625C6.6843748 11.096875 7.3187499 11.096875 7.7093749 10.70625L12.709375 5.7062502C13.1 5.3156252 13.1 4.6812496 12.709375 4.2906246C12.31875 3.8999996 11.684376 3.8999996 11.293751 4.2906246L7 8.5843754L2.7062502 4.2937498C2.3156252 3.9031248 1.6812501 3.9031248 1.2906251 4.2937498C0.9000001 4.6843748 0.9000001 5.3187504 1.2906251 5.7093754L6.2906251 10.709375L6.2937498 10.70625Z" />
                                            </svg>
                                        </i>
                                        {item.label}
                                    </span>
                                )}
                            </span>
                        );
                    })}
                </div>
            )}
            <nav className='navbar navbar-expand-lg sidenav' id="sidenav-1" data-mdb-hidden="false">
                {role === 'migration-manager' &&
                    <span className='role-badge' title='Internal account: payment is skipped for full and delta migrations'>Migration Manager</span>
                }
                <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div className='user-img'>
                            <img src={require('../../static/images/user-img.png')} alt='' />
                        </div>
                        {email || 'Profile'}
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item" onClick={logout}> Logout </a>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default NavbarInner;